<template>
  <router-link :to="to" tag="li" class="nav-item" active-class="uk-active">
    <a class="nav-item__link">
      <icon v-if="icon" :name="icon" class="uk-margin-small-right" />
      <slot>{{text}}</slot>
    </a>
  </router-link>
</template>

<script>
export default {
  name: 'nav-item',
  props: {
    to: Object,
    text: String,
    icon: String,
  },
};
</script>

<style lang="scss" scoped>
.nav-item__link {
  padding: {
    top: 7px;
    bottom: 7px;
  }
}
</style>



// WEBPACK FOOTER //
// NavItem.vue?2fbaf45e